module.exports = __webpack_public_path__ + "static/img/7.5cf9cb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/7.png
// module id = ea6b
// module chunks = 0